
import { Component, Prop, Vue } from "vue-property-decorator";
import { TEmployeeSummary } from "@/models/employees";
import { SMUser } from "@/store";
import CheckmarkCircleIcon from "@/assets/images/icons/checkmark-circle.svg";
import AlertCircleIcon from "@/assets/images/icons/alert-circle.svg";

@Component({})
export default class EmployeeSummaryDetails extends Vue {
  @Prop({ type: Object, required: true }) readonly employeeSummary!: TEmployeeSummary;

  statuses = {
    undetermined: this.$root.$tc("labels.undetermined"),
    compliant: this.$root.$tc("labels.compliant"),
    not_compliant: this.$root.$tc("labels.notCompliant"),
  };

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  get complianceStatus() {
    const status = this.employeeSummary?.compliance;

    if (this.isComplianceBlocked || !status) return this.$root.$tc("labels.undetermined");

    return this.statuses[status];
  }

  get classes() {
    if (this.complianceStatus === this.$root.$tc("labels.compliant")) return `compliant`;

    if (this.complianceStatus === this.$root.$tc("labels.notCompliant")) return `noncompliant`;

    return `compliant_unknown`;
  }

  get isCompliant() {
    return this.complianceStatus === this.$root.$tc("labels.compliant");
  }

  get iconName() {
    return this.isCompliant ? CheckmarkCircleIcon : AlertCircleIcon;
  }
}
